import KatexText from './KatexText';
export default KatexText;